module.exports = __webpack_public_path__ + "img/pieceOneImg3.0fe216f.png";